<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (OnSave)="Save()"></app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name">
              <div class="control">
                <input formControlName="Name" class="input" type="text" />
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Description">
              <div class="control">
                <input formControlName="Description" class="input" type="text" />
                <app-validator [For]="this.Form.get('Description')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Total Spaces Mode" tippy="Determines how the total number of spaces is calculated for this parking lot">
              <div class="control select">
                <select formControlName="TotalSpacesMode" class="input">
                  <option [ngValue]="0">Spaces From Design</option>
                  <option [ngValue]="1">Specified Count</option>
                </select>
              </div>
            </app-field>
            <app-field Label="Space Count">
              <div class="control">
                <input formControlName="TotalSpaces" class="input" type="number" [readonly]="Form.get('TotalSpacesMode')?.value === 0" />
                <app-validator [For]="this.Form.get('TotalSpaces')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Reserved Spaces" tippy="Number of spaces that are reserved and not available for general parking">
              <div class="control">
                <input formControlName="ReservedSpaces" class="input" type="number" min="0" />
                <app-validator [For]="this.Form.get('ReservedSpaces')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Occupancy Count Mode" tippy="The method used to determine occupancy count. 'Default' mode adds up occupancy reported for each level. 'Count In/Out' mode uses car counters/access control to track vehicles entering/leaving and does not use Level occupancy figures.">
              <div class="control">
                <div class="select">
                  <select formControlName="AvailabilityCountMode" class="input">
                    <option value="Default">Default</option>
                    <option value="VehiclesPresent">Count in/out</option>
                    <option value="External">External</option>
                  </select>
                </div>
              </div>
            </app-field>
            <app-field Label="External Id" tippy="An ID used by external providers we've integrated with to link this lot to their system">
              <div class="control">
                <input formControlName="ExternalId" class="input" type="text" />
                <app-validator [For]="this.Form.get('ExternalId')"></app-validator>
              </div>
            </app-field>
            @if (this.Form.get('AvailabilityCountMode')?.value == 'External') {
              <app-field Label="External Count Provider" tippy="The external provider used to set occupancy count.">
                <div class="control">
                  <div class="select">
                    <select formControlName="ExternalCountProvider" class="input">
                      <option value="" hidden>None Selected</option>
                      @for (opt of GetExternalCountProviders(); track opt) {
                        <option value="{{opt.Name}}">{{opt.Name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
            }
            @if (this.Form.get('AvailabilityCountMode')?.value == 'External' && this.Form.get('ExternalCountProvider')?.value != null) {
              <app-field Label="External Count Source" tippy="The external source used to set occupancy count.">
                <div class="control">
                  <div class="select">
                    <select formControlName="ExternalCountProviderSourceId" class="input">
                      <option value="" hidden>None Selected</option>
                      @for (opt of GetExternalCountSources(this.Form.get('ExternalCountProvider')?.value); track opt) {
                        <option value="{{opt.Id}}">{{opt.Name}}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
            }
            <app-field Label="Open/Closed Status" [HasAddons]="true" tippy="Whether or not the lot is open for parking. Can be triggered automatically using Threshold Sets.">
              <div class="control">
                <div class="select">
                  <select formControlName="ClosedByUser" class="input">
                    <option [value]="false">Open</option>
                    <option [value]="true">Closed</option>
                  </select>
                </div>
              </div>
              @if (Model.ClosedBySystem == true) {
                <div class="control">
                  <span class="button is-danger" >Currently closed due to {{Model.OccupiedPercent}} Occupancy</span>
                </div>
              }
            </app-field>
            <app-field Label="Threshold Set" tippy="Governs the color of the parking lot based on occupancy. Threshold sets can also close a parking lot at certain thresholds and reopen them when occpancy falls.">
              <div class="control">
                @if (ThresholdSets != null) {
                  <div class="select">
                    <select formControlName="ParkingThresholdSetId" class="input" type="text">
                      <option value=""></option>
                      @for (a of ThresholdSets; track a) {
                        <option [ngValue]="a.Id">{{a.Name}}</option>
                      }
                    </select>
                  </div>
                }
                @if (ThresholdSets == null) {
                  <span>
                    Loading...
                  </span>
                }
              </div>
            </app-field>
            <app-field Label="Auto Occupancy Reset" tippy="If enabled, the occupancy count will be reset at regular intervals. This is used to combat drift in lots where count in/out is used and missed counts can cause increased inaccuracy over time.">
              <div class="control">
                <div class="select">
                  <select formControlName="ResetMode" class="input" type="text">
                    <option value="0">None</option>
                    <option value="1">Daily</option>
                    <option value="2">Weekly</option>
                    <option value="3">Monthly</option>
                  </select>
                </div>
              </div>
            </app-field>
            @if (this.Form.get('ResetMode')?.value != 0) {
              <app-field Label="Reset Time">
                <div class="control">
                  <div class="select">
                    <select formControlName="OccupancyResetTime" class="input">
                      @for (i of resetTimeSlots; track i) {
                        <option [ngValue]="i.v">{{i.k}}</option>
                      }
                    </select>
                  </div>
                </div>
              </app-field>
            }
            <app-field Label="Paid Parking"
              tippy="Governs whether or not the Parking Lot requires payment. This allows the app to not display this as an option in Pay for Parking">
              <div class="control">
                <app-toggleswitch formControlName="IsPaidParking"></app-toggleswitch>
              </div>
            </app-field>
            @if (Form.get('IsPaidParking')?.value == true) {
              <app-field Label="Default Rate Set" tippy="Change the default rate set applied to this parking lot">
                <div class="control">
                  @if (RateSets != null) {
                    <div class="select">
                      <select formControlName="ParkingRateSetId" class="input" type="text">
                        <option value=""></option>
                        @for (a of RateSets; track a) {
                          <option [ngValue]="a.Id">{{a.Name}}</option>
                        }
                      </select>
                    </div>
                  }
                  @if (RateSets == null) {
                    <span>
                      Loading...
                    </span>
                  }
                </div>
              </app-field>
            }
            <app-field Label="Default Customer Group" tippy="Default customer group for sessions in this parking lot (used as fallback when permit/validation/rateset don't specify one)">
              <div class="control">
                @if (CustomerGroups != null) {
                  <div class="select">
                    <select formControlName="CustomerGroupId" class="input" type="text">
                      <option value="">None</option>
                      @for (cg of CustomerGroups; track cg) {
                        <option [ngValue]="cg.Id">{{cg.Name}}</option>
                      }
                    </select>
                  </div>
                }
                @if (CustomerGroups == null) {
                  <span>
                    Loading...
                  </span>
                }
              </div>
            </app-field>
            @if (Form.get('IsPaidParking')?.value == true) {
              <app-field Label="Payment Mode" tippy="Defines when the payment is expected to be taken, either before or after the session has begun">
                <div class="control">
                  <div class="select">
                    <select formControlName="PaymentMode" class="input">
                      <option value="0" tippy="Pay on Exit">Post Pay</option>
                      <option value="1" tippy="Pay for selected time">Pre Pay</option>
                    </select>
                  </div>
                </div>
              </app-field>
            }
            <app-field Label="Payment Target"
              tippy="Governs whether or not users must provide a Space Name when paying for parking or applying a permit. If each space is physically marked with an identifier then Marked Spaces Mode should be used, however some lots have no markings, in which case Unmarked Spaces Mode should be used.">
              <div class="control">
                <div class="select">
                  <select formControlName="PaymentRequiresSpaceName" class="input">
                    <option [ngValue]="true">Marked Spaces - User must select a Space</option>
                    <option [ngValue]="false">Unmarked Spaces - User selects Lot only </option>
                  </select>
                </div>
              </div>
            </app-field>
            <app-field Label="Permit Parking">
              <div class="control">
                <app-toggleswitch formControlName="IsPermitParking"></app-toggleswitch>
              </div>
            </app-field>
            <app-field Label="Type">
              <div class="control select">
                <select formControlName="Type" class="input">
                  <option [ngValue]="0">On-Street Parking</option>
                  <option [ngValue]="100" [disabled]="Form.get('Levels')?.value.length > 1">Single Level</option>
                  <option [ngValue]="200">Multi Level</option>
                </select>
              </div>
            </app-field>
            <app-field Label="Coverage Type" tippy="Whether the parking lot is covered, uncovered, or partially covered. Shown to mobile app users.">
              <div class="control select">
                <select formControlName="CoverageType" class="input">
                  <option [ngValue]="0">Unknown</option>
                  <option [ngValue]="100">Covered</option>
                  <option [ngValue]="200">Uncovered</option>
                  <option [ngValue]="300">Partially Covered</option>
                </select>
              </div>
            </app-field>
            <app-field Label="Entry Instructions" tippy="Directions shown to mobile app users for finding and entering this parking lot.">
              <div class="control">
                <textarea formControlName="EntryInstructions" class="textarea" rows="4"></textarea>
              </div>
            </app-field>
            <app-field Label="Enable Global Directory">
              <div class="control">
                <app-toggleswitch formControlName="EnableGlobalDirectory"></app-toggleswitch>
              </div>
            </app-field>
            <app-field Label="Requires Recent Meter Activity For Violations" tippy="When enabled, enforcement violations will only be created if there has been recent activity from parking meters in the area">
              <div class="control">
                <app-toggleswitch formControlName="RequiresRecentMeterActivity"></app-toggleswitch>
              </div>
            </app-field>
          </div>
        </article>
        <article class="panel">
          <p class="panel-heading">
            {{((Form.get('Type')?.value >= 100) ? 'Levels' : 'Zones')}}
          </p>
          <a class="panel-block">
            <span class="value">
              <div class="control" formArrayName="Levels">
                <table class="table is-striped is-bordered is-fullwidth">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Spaces</th>
                      <th>Manage</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (level of FormArray(Form, 'Levels').controls; track level; let i = $index) {
                      <tr
                        [formGroupName]="i">
                        <td><input type="text" class="input is-shortest" formControlName="LevelNumber">
                        </td>
                        <td><input type="text" class="input" formControlName="Name" /></td>
                        <td><input type="text" class="input is-static" readonly
                        formControlName="TotalSpaces" /></td>
                        <td style="vertical-align: inherit;">
                          <button type="button"
                            (click)="EditLevel(level)"
                            class="button is-link is-small ng-star-inserted mr-2">
                            Details
                            <i class="ml-2 fa fa-chevron-right"></i>
                          </button>
                          <button type="button"
                            (click)="EditLevelDesign(level)"
                            class="button is-link is-small ng-star-inserted">
                            Designer
                            <i class="ml-2 fa fa-pen-ruler"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="99">
                        <button class="button is-primary is-outlined is-fullwidth"
                          (click)="AddLevel()">Add
                        {{(Form.get('Type')?.value > 0) ? 'Level' : 'Zone'}}</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </span>
          </a>
        </article>
        <article class="panel">
          <p class="panel-heading">
            Links
          </p>
          <a class="panel-block">
            <span class="value">
              <div class="control" formArrayName="Links">
                <table class="table is-striped is-bordered is-fullwidth">
                  <thead>
                    <tr>
                      <th>Linked Lot</th>
                      <th>Direction</th>
                      <th>Adjustable</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (link of FormArray(Form, 'Links').controls; track link; let i = $index) {
                      <tr
                        [formGroupName]="i">
                        <td>
                          <div class="select">
                            <select formControlName="ParkingLotId" class="input">
                              <option value="" hidden>Select Parking Lot</option>
                              @for (lot of AvailableParkingLots; track lot) {
                                <option [ngValue]="lot.Id">{{lot.Name}}</option>
                              }
                            </select>
                          </div>
                        </td>
                        <td>
                          <div class="select">
                            <select formControlName="Direction" class="input">
                              <option [ngValue]="0">Two Way</option>
                              <option [ngValue]="1">One Way (This Lot to Other)</option>
                              <option [ngValue]="2">One Way (Other to This Lot)</option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <app-toggleswitch formControlName="IsAllocationAdjustable"></app-toggleswitch>
                        </td>
                        <td>
                          <button type="button" class="button is-danger is-small" (click)="RemoveLink(i)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="99">
                        <button class="button is-primary is-outlined is-fullwidth" (click)="AddLink()">
                          Add Link
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </span>
          </a>
        </article>
      </div>
      <div class="column is-6">
        <!-- <app-lotviewer *ngIf="Model != null && Model.Levels.length > 0" [ParkingLotId]="Model.Id" ></app-lotviewer> -->
        <app-map-input formControlName="GeoPolygonPoints" MapWidth="100%" MapHeight="500" [Editable]="true"
          [BackgroundPolygonPoints]="MapItems">
        </app-map-input>
      </div>
    </div>
  </div>
}